import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { Stack } from '@fiverr-private/layout_components';
import { NewBadge } from '@fiverr-private/badges';
import { translate } from '@fiverr-private/i18n-react';
import Link from '../Links/Link';
import { HEADER_NAV_SOURCE } from '../../constants';

interface FiverrGoBadgeProps {
    showFitNewBadge?: boolean;
    isSeller?: boolean;
}
export const FiverrGoBadge: React.FC<FiverrGoBadgeProps> = ({ showFitNewBadge = false, isSeller = false }) => {
    const text = translate('header.fiverr_go');

    const key = isSeller ? 'seller_ai_hub_page' : 'go_explore_landing_page';
    const href = pathfinder(key, {}, { query: { source: HEADER_NAV_SOURCE } });

    return (
        <Link href={href} className="nav-link" isNew={showFitNewBadge}>
            {showFitNewBadge ? (
                text
            ) : (
                <Stack alignItems="center" gap="3">
                    <span>{text}</span>
                    <NewBadge />
                </Stack>
            )}
        </Link>
    );
};
